import * as React from "react";

import styles from "../styles/pages/sign-up.module.scss";

import { Button } from "@mui/material";
import Typography from '@mui/material/Typography';

import { useState } from 'react';
import { Link } from "react-router-dom";
import { createUser } from "../api/auth";
import { CreateForm } from '../components/form-components';
import { Meta } from "../components/meta";
import { LoginPageWrapper } from '../components/mui-login-page-wrapper';
import { StyledMarkdown } from "../components/typeface";
import { introSignUpMessage } from "../data/content";
import { signUpShape } from '../data/form-shapes';
import { validatePassword } from '../helpers/core';

export const SignUpPage: React.FC<any> = () => {
  const [pageError, setPageError] = useState<string[]>([]);
 
  const [showMessage, setShowMessage] = useState(false)
  // const SignUpTheme = createTheme(getSignUpTheme(mode));
  const [signUpError, setSignUpError] = useState<string[]>([])

  // This code only runs on the client side, to determine the system color preference
  // useEffect(() => {
    // Check if there is a preferred mode in localStorage
    // const savedMode = localStorage.getItem('themeMode') as any | null;
    // if (savedMode) {
    //   setMode(savedMode);
    // } else {
    //   // If no preference is found, it uses system preference
    //   const systemPrefersDark = window.matchMedia(
    //     '(prefers-color-scheme: dark)',
    //   ).matches;
    //   setMode(systemPrefersDark ? 'dark' : 'light');
    // }
  // }, []);
  
  if (showMessage) {
    return (
      <LoginPageWrapper
        title='Sign up' 
        error={signUpError}
      >
      <>
        <Meta title="Create a free account for MetOceanAtlas" />
        <p>We have generated a welcome email. Please check your inbox and follow the steps to complete your sign up.</p>
      </>
    </LoginPageWrapper>
    )
  }

  return (
    <LoginPageWrapper
      title='Sign up' 
      error={[...signUpError, ...pageError]}
      fullHeight
    >
      <div className={styles.leftPanel}>
        <Meta title="Create a free account for MetOceanAtlas" />
        <StyledMarkdown>
          {introSignUpMessage}
        </StyledMarkdown>
        
        <p>Create a <strong>free account</strong> to purchase and explore data on the platform. Or {' '}
          <span>
            <Link
              to="/login"
              // variant="body2"
              // sx={{ alignSelf: 'center' }}
            >
              sign in
            </Link>
          </span>{' '}if you already have an account.
        </p>
        <p>- <strong>OR</strong> -</p>
        <Button
          variant="outlined"
          component={Link}
          to="/dashboard"
          fullWidth
        >Explore without account</Button>

        <h5>Models description</h5>
        <ul>
          <li><a target="_blank" href="/models/mow-swan-europe-null/">MOW European Wave Hindcast</a></li>
          <li><a target="_blank" href="/models/mow-mike21-europe-null/">MOW European Hydrodynamic Hindcast</a></li>
        </ul>
      </div>
      <div>
        <CreateForm
          isModal={false}
          shape={signUpShape}
          submitButtonLabel="Sign up"
          oneButtonSubmit
          successMessage="Your account has been created"
          defaultValues={null}
          onError={() => {
            // setLoading(false)
            setSignUpError([])
          }}
          onChange={(vals) => {
            const {password, password_two} = vals
            if (password && password_two) {
              const {isValid} = validatePassword(password)
              const isMatching = !!(password === password_two)
              if ( !isMatching || (isMatching && !isValid)) {
                const failedPasswordMessage = isValid ? [] : ['Your password must be at least 6 characters long and contain both letters and numbers.']
                const matchingMessage = isMatching ? [] : ['Both passwords must be matching...']
                setPageError([...matchingMessage, ...failedPasswordMessage])
              } else {
                setPageError([])
              }
            }
          }}
          onSuccess={() => {
            setShowMessage(true)
            // setLoading(false)
          }}
          onSubmit={(vals ) => {
            // setLoading(true)
            const {
              email,
              first_name,
              last_name, 
              user_organisation, 
              job_title, 
              password
            } = vals
            return createUser({
              email,
              first_name, 
              last_name, 
              user_organisation, 
              job_title, 
              password
            })
          }}
        />
        <Typography sx={{ textAlign: 'center' }}>
          Already have an account?{' '}
          <span>
            <Link
              to="/login"
              // variant="body2"
              // sx={{ alignSelf: 'center' }}
            >
              Sign in
            </Link>
          </span>
        </Typography>
      </div>
    </LoginPageWrapper>
  )
}

export default SignUpPage

export const Head: any = () => <title>Sign-up</title>
